export default "__VITE_ASSET__DApQMzYs__"